import { render } from "./cancellationPage.vue?vue&type=template&id=13b2b293"
import script from "./cancellationPage.vue?vue&type=script&lang=js"
export * from "./cancellationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__